// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header__1hCuT","header_hexa":"Header__header_hexa__1gvbS","header_open":"Header__header_open__Nnp90"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/Header.scss
// module id = 122
// module chunks = 0